module.exports = __webpack_public_path__ + "media/23.c562c362.mp3";